import {
  Box,
  Button,
  Text,
  Flex,
  Icon,
} from '@chakra-ui/react';
import { FiRefreshCcw } from 'react-icons/fi';

const NewVersionModal = ({ isOpen, onRefresh }) => {
  // Si no hay nueva versión, no mostramos nada
  if (!isOpen) return null;

  return (
    <Box
      position="fixed"
      bottom="20px"
      left="20px"
      right="20px"
      bg="blue.500"
      color="white"
      p={4}
      borderRadius="md"
      boxShadow="lg"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      zIndex={9999}
    >
      <Flex alignItems="center">
        <Icon as={FiRefreshCcw} mr={3} />
        <Text fontWeight="medium">
          Hay una nueva versión disponible
        </Text>
      </Flex>
      
      <Button
        onClick={onRefresh}
        bg="white"
        color="blue.500"
        size="sm"
        fontWeight="bold"
        _hover={{
          bg: "gray.100"
        }}
      >
        Actualizar ahora
      </Button>
    </Box>
  );
};

export default NewVersionModal; 